import React from 'react';

import SVG from '../../../components/SVG';

import styles from './style.css';

const ContactForm = ({
  values: { email, name, message },
  touched,
  errors,
  isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit
}) => (
  <form onSubmit={handleSubmit} className={styles.contact__form}>
    <div className={styles.contact__form__text}>
      Let’s start talking about your new amazing app
    </div>
    <input
      type="email"
      placeholder="Email (required)"
      name="email"
      onChange={handleChange}
      onBlur={handleBlur}
      value={email}
      disabled={isSubmitting}
    />
    <input
      type="text"
      placeholder="Name"
      name="name"
      onChange={handleChange}
      onBlur={handleBlur}
      value={name}
      disabled={isSubmitting}
    />
    <textarea
      placeholder="Message"
      name="message"
      onChange={handleChange}
      onBlur={handleBlur}
      value={message}
      rows="2"
      disabled={isSubmitting}
    />
    <div className={styles.contact__form__footer}>
      <div className={styles.contact__form__error}>
        {Object.keys(errors)
          .reduce((result, key) => {
            if (touched[key] && errors[key]) {
              result.push(errors[key]);
            }

            return result;
          }, [])
          .join('\n')}
      </div>
      {!isSubmitting && (
        <button className={styles.contact__form__footer__submit} type="submit">
          Send
        </button>
      )}
      {isSubmitting && (
        <div className={styles.contact__form__footer__submit__spinner}>
          <SVG viewBox="0 0 16.4 16.4">
            <circle cx="50%" cy="50%" r="7" />
          </SVG>
        </div>
      )}
    </div>
  </form>
);

export default ContactForm;
